/* src/app/intern/intern-details/notes-contacts/notes-contacts.component.scss */
.container {
  width: 100%;
  margin: 20px;
}
table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;
  margin-bottom: 20px;
}
th.mat-mdc-header-cell {
  background-color: #f0f0f0;
  color: #999;
  font-weight: 600;
  padding: 15px 0;
  cursor: pointer;
}
td.mat-mdc-cell {
  padding: 5px;
  border-bottom: 1px solid #ccc;
  text-align: left;
}
button {
  margin-left: 5px;
  border-radius: 22px;
}
.button-large {
  margin-left: 15px;
  border-radius: 22px;
  width: 200px;
  margin-top: 6px;
  font-size: medium;
}
.mat-column-Type {
  width: 140px;
}
.mat-column-Note {
  width: 60%;
}
.mat-column-UpdatedBy,
.mat-column-CreatedBy {
  max-width: 120px;
}
.mat-column-Priority {
  text-align: center !important;
}
.mat-column-UpdateDate {
  max-width: 120px;
  white-space: nowrap;
}
#newNote {
  width: 100%;
  height: 100px;
}
.add-note-minimized,
.add-note-fullscreen {
  margin: 20px 0px;
}
.add-note-minimized {
  width: 400px;
}
.add-note-fullscreen {
  width: 600px;
}
.updateNoteInput {
  width: 100%;
  height: 80px;
}
.editNoteButton {
  margin-left: -20px;
}
.compact-note-list {
  width: 95%;
  max-width: 800px;
}
.compact-note {
  background: #ffffff;
  border-top: 2px solid #6E6E6E;
  border-bottom: 2px solid #6E6E6E;
  color: #000;
}
.compact-note-head {
  border-bottom: 1px solid #aeaeae;
  padding: 15px 10px 5px 10px;
  font-size: small;
}
.compact-note-body {
  padding: 0px 10px 15px 10px;
}
.compact-note-head mat-icon {
  float: right;
  top: -5px;
  position: relative;
  color: #B62A39;
}
.compact-note-body,
.existingNote {
  max-height: 70px;
  overflow-y: auto;
}
/*# sourceMappingURL=notes-contacts.component.css.map */
